import { Record, Map } from "immutable";

export default Record({
  isRemoveModalVisible: false,
  meta: new (Record({
    all: 0,
    count: 0,
    limit: 100,
    currentPage: 0
  }))(),
  loading: false,
  entities: new Map([]),
  results: []
});



// WEBPACK FOOTER //
// ./src/common/audits/audits.js